<template>
<PPage title="Sales Boosting" :primaryAction="{
        content: 'Back',
        onAction: routeback,
        }">
        <PLayout>
    <PLayoutAnnotatedSection
    title="Premium Settings"
    description="You can view and manage your Subscription Settings here.">
  
  
      <PLayout sectioned>
       
        <PBanner style="margin-bottom:25px" status="success">Upgraded to Premium</PBanner>
        
          
        <PCard title="Details" sectioned>
            <!---  Später  mit GET?  ---->
            <PTextContainer>
                <h2><b>Salesboosting PREMIUM</b></h2>
                <p>ID: {{appData.id}}</p>
                <p>Status: <PBadge status="success">{{appData.status}}</PBadge></p>
                <p>Created: {{fullDate}}</p>
                <p>Price: <PBadge status="info">{{appData.price}} $</PBadge></p>

            </PTextContainer>
        </PCard> 
       
    
      </PLayout>
   
        <PButton @click="this.loadingstatec = true" :loading="loadingstatec" :href="`https://us-central1-sales-boosting-bb.cloudfunctions.net/appchargecancel`+ `?shop=` + this.$route.query.shop + '&myAuth=' + this.$route.query.myAuth" primary fullWidth textAlign="center" size="large" style="margin-top:25px">Cancel Subscription</PButton>
  

  
    </PLayoutAnnotatedSection>
        </PLayout>
</PPage>
</template>

<script>
import { db } from '../firebase'

export default {
    data() {
        return {
            appData: {},
            loadingstatec: false,
            date: '',
            day: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            month: ['January','February','March','April','May','June','July','August','September','October','November','December'],
            daysuffix: ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th', '11th', '12th', '13th', '14th', '15th', '16th', '17th', '18th', '19th', '20th', '21st', '22nd', '23rd', '24th', '25th', '26th', '27th', '28th', '29th', '30th', '31st']
        }
    },
  methods: {
      routeback() {
          this.$router.push('/')
      }
  },
  computed: {
    fullDate() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.date = this.day[new Date(this.appData.createdAt).getDay()] +', '+ this.daysuffix[new Date(this.appData.createdAt).getDate()-1] +' '+ this.month[(new Date(this.appData.createdAt).getMonth())] +' '+ new Date(this.appData.createdAt).getFullYear().toString()
        return this.date
    }
  },
  async created() {
          const data = await db.collection('shops').doc(this.$route.query.shop).collection('appcharge').doc('data').get()
          this.appData = data.data()
      
  },
  mounted () {
      this.loadingstatec = false
  }
}
</script>
